(function () {
  'use strict';

  /* ---------------- Announcement bar slider ---------------- */
  var bar = document.querySelector('[data-focal-announcement-bar]');
  if (bar) {
    var track = bar.querySelector('[data-focal-announcement-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var index = 0;
    var timer = null;
    var autoplay = bar.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;

    function goTo(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function startAutoplay() { stopAutoplay(); if (autoplay && slides.length > 1) timer = setInterval(next, speed); }
    function stopAutoplay() { if (timer) clearInterval(timer); }

    var nextBtn = bar.querySelector('[data-focal-announcement-next]');
    var prevBtn = bar.querySelector('[data-focal-announcement-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    bar.addEventListener('mouseenter', stopAutoplay);
    bar.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  /* ---------------- Sticky header shadow on scroll ---------------- */
  var header = document.querySelector('[data-focal-header]');
  if (header && header.classList.contains('focal-header--sticky')) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------------- Locale / currency panel ---------------- */
  var localeToggle = document.querySelector('[data-focal-locale-toggle]');
  var localePanel = document.querySelector('[data-focal-locale-panel]');
  if (localeToggle && localePanel) {
    localeToggle.addEventListener('click', function () {
      var expanded = localeToggle.getAttribute('aria-expanded') === 'true';
      localeToggle.setAttribute('aria-expanded', String(!expanded));
      localePanel.hidden = expanded;
    });
    document.addEventListener('click', function (e) {
      if (!localeToggle.contains(e.target) && !localePanel.contains(e.target)) {
        localePanel.hidden = true;
        localeToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------------- Mobile hamburger nav ---------------- */
  var mobileNav = document.querySelector('[data-focal-mobile-nav]');
  var mobileOverlay = document.querySelector('[data-focal-mobile-nav-overlay]');
  var mobileOpenBtn = document.querySelector('[data-focal-mobile-nav-open]');
  var mobileCloseBtn = document.querySelector('[data-focal-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileOverlay.hidden = false;
    mobileNav.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      mobileOverlay.classList.add('is-visible');
      mobileNav.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileOverlay.classList.remove('is-visible');
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { mobileOverlay.hidden = true; }, 400);
  }

  if (mobileOpenBtn) mobileOpenBtn.addEventListener('click', openMobileNav);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav();
  });

  document.querySelectorAll('[data-focal-mobile-accordion]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.nextElementSibling;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (submenu) submenu.classList.toggle('is-open', !expanded);
    });
  });

  /* ---------------- Open triggers for search / cart drawers ---------------- */
  document.querySelectorAll('[data-focal-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('focal:search-open')); });
  });
  document.querySelectorAll('[data-focal-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('focal:cart-open')); });
  });
})();